<template lang="pug">
section.p-top
  section.container
    .text-center
      .d-flex.justify-content-center.align-items-center.cart-bg
        vue-typed-js(:strings="['感谢您对99Ro的支持~']", :fadeOut="true")
          h3.text-white.typing.cart-text
    //- 关闭
    .my-5.row.justify-content-center(v-if="process == -1")
      .col-md-6
        .row
          .col-md-5.text-center
            img(
              src="http://res.99ro.top/web-assets/img/coin.png",
              alt="",
              srcset="",
              style="width:150px; height:150px; margin-bottom:16px;"
            )
          .col-md-7.text-left
            label.h4.text-danger(style="margin-right:20px; line-height:150px;") 暂未开放，敬请期待！
    //- 开启
    .my-5.row.justify-content-center(v-if="process == 0 && pay_type == ''")
      .col-md-3.text-center
        img(
          src="http://res.99ro.top/web-assets/img/coin.png", 
          alt="赞助Vis币",
          srcset="",
          style="width:150px; height:150px; margin-bottom:16px;"
        )
        br
        h5.text-info Vis币用于商城内的所有商品
        h5.text-info （不包含VIP月卡）
        button.btn.btn-danger(@click="pay_type = 'coin'") 赞助Vis币
      .col-md-3.text-center
        img(
          src="http://res.99ro.top/web-assets/img/ticket.png",
          alt="赞助VIP票",
          srcset="",
          style="width:150px; height:150px; margin-bottom:16px;"
        )
        br
        h5.text-info VIP票只能兑换VIP月卡
        h5.text-info （进入赞助查看详细说明）
        button.btn.btn-danger(@click="pay_type = 'ticket'") 赞助VIP票
    .my-5.row.justify-content-center(v-if="process == 0 && pay_type == 'ticket'")
      .col-md-6.text-center
        img(
          src="http://res.99ro.top/web-assets/img/vip-info-new.jpg",
          alt="",
          srcset="",
          style="width: 274px; height: 437px; margin-bottom:16px;"
        )
    .my-5.row.justify-content-center(v-if="process == 0 && pay_type != ''")
      form.col-md-6(@submit.prevent="confirmOrder()", ref="form")
        .form-group
          label(for="userid") 用户名
          input#userid.form-control(
            type="text",
            name="userid",
            v-validate="{ min:6, max:14, required:true, alpha_num:true }",
            :class="{ 'is-invalid': errors.has('userid') }",
            v-model="form.userid",
            placeholder="请输入用户名"
          )
          span.text-danger(v-if="errors.has('userid')") 请输入要赞助的账号
        .form-group
          label(for="money") 选择赞助金额
          //- 赞助vis
          select#money.form-control(
            name="money",
            :class="{ 'is-invalid': errors.has('money') }",
            v-model="form.money",
            v-validate="{ required: true }",
            placeholder="选择赞助金额",
            v-if="pay_type == 'coin'"
          )
            //- option(label="1元 = 测试", :value="1")
            option(label="10元 = 100Vis", :value="10")
            option(label="50元 = 550Vis", :value="50")
            option(label="100元 = 1100Vis", :value="100")
            option(label="200元 = 2200Vis", :value="200")
            option(label="500元 = 5550Vis", :value="500")
            option(label="1000元 = 12000Vis", :value="1000")
            option(label="1500元 = 18000Vis", :value="1500")
            option(label="2000元 = 25000Vis", :value="2000")
          //- h5.text-danger(v-if="pay_type == 'coin'", style="margin-top:6px;") 因平台限制关闭2000档线上赞助(2000 = 25000Vis)
          //-   br 
          //-   | 若需此档优惠请直接联系客服QQ：1941160499 
          
          //- 赞助vip
          select#money.form-control(
            name="money",
            :class="{ 'is-invalid': errors.has('money') }",
            v-model="form.money",
            v-validate="{ required: true }",
            placeholder="选择赞助金额",
            v-if="pay_type == 'ticket'"
          )
            option(label="10元 = 1张VIP票", :value="10")
            option(label="30元 = 3张VIP票", :value="30")
            option(label="60元 = 6张VIP票", :value="60")
            option(label="90元 = 9张VIP票", :value="90")
            option(label="180元 = 18张VIP票", :value="180")
          span.text-danger(v-if="errors.has('money')") 请选择需要赞助的金额
          h5.text-warning(v-if="pay_type == 'ticket'", style="margin-top:6px;") VIP票 x 6张 换取 会员证盒子(30天) x 1个
        .text-right
          span.text-danger(
            style="margin-right:20px;",
            v-if="form.result.code != 0"
          ) {{ form.result.message || '订单创建失败，请联系客服处理。QQ号: 1941160499' }}
          button.btn.btn-danger(v-if="!submitHide") 去赞助
          .text-center(v-else)
            label.h5.text-danger 线上赞助通道调整，暂时关闭
            label.h5.text-danger 若需赞助请直接联系客服QQ：1941160499
          button.btn.btn-info(@click="reset", style="margin-left:20px;") 重新选择
        br
        h5.text-info 赞助成功后，请在游戏中找NPC“商城销售员”领取订单商品
    .my-5.row.justify-content-center(v-if="process == 0 && pay_type == 'coin'")
      .col-md-10.text-center
        h5.text-ro-light 同账号累积赞助Vis币达到一定金额，可联系客服领取以下限定属性时装头饰
        .row(style='margin:20px 0;')
          .col-md-4
            img(src="http://res.99ro.top/web-assets/img/item/item_30053.jpg",style="width:100%; height:186px; margin-bottom:10px;")
            h5.text-danger 累积赞助2500RMB
          .col-md-4
            img(src="http://res.99ro.top/web-assets/img/item/item_30052.jpg",style="width:100%; height:186px; margin-bottom:10px;")
            h5.text-danger 累积赞助5000RMB
          .col-md-4
            img(src="http://res.99ro.top/web-assets/img/item/item_30051.jpg",style="width:100%; height:186px; margin-bottom:10px;")
            h5.text-danger 累积赞助10000RMB
      .col-md-7
        h5.text-ro-light 累积10000RMB时可同时获得以上三个头饰，例如：
        ul.text-ro-light(style='margin: 0 auto;')
          li 赞助  2500RMB 时获得：赤金贵族帽 x 1个
          li 赞助  5000RMB 时获得：黄金贵族帽 x 1个 + 赤金贵族帽 x 1个
          li 赞助 10000RMB 时获得：白金贵族帽 x 1个 + 黄金贵族帽 x 1个 + 赤金贵族帽 x 1个
          li.text-warning 注意：超过 10000RMB 后重新开始累计
      //- .col-md-6
        h5.text-ro-light 举例：累积10000RMB时可选择领取以下方案的其中一种：
        ul.text-ro-light(style='margin: 0 auto;')
          li 白金贵族帽 x 1个
          li 黄金贵族帽 x 2个
          li 黄金贵族帽 x 1个 + 赤金贵族帽 x 2个
          li 赤金贵族帽 x 4个
    .my-5.row.justify-content-center(v-if="process == 1")
      .col-md-6.text-center
        img(
          :src="form.result.pay_qrcode",
          alt="请用支付宝扫码支付",
          srcset="",
          style="width: 300px; height: 300px; margin-bottom:16px;"
        )
        br
        h3.text-ro-light(v-if="form.notifyResult.message") {{ form.notifyResult.message }}
        h3.text-ro(v-else="") 请用支付宝进行扫码支付
        //- a(:href="form.result.pay_url",target="_blank") 或点此跳转到支付宝页面进行扫码
        h4.text-warning 有任何问题请联系客服处理 QQ: 1941160499
        h5.text-danger 支付成功后若页面未刷新，请点击按钮手动刷新结果
        button.btn.btn-info(@click="refreshOrder") 手动刷新
    .my-5.row.justify-content-center(v-if="process == 2")
      .col-md-6
        .row
          .col-md-4
            img(
              src="http://res.99ro.top/web-assets/img/8.jpg",
              style="width:150px; height:150px; margin-bottom:16px;"
            )
          .col-md-8.text-left
            label.h4.text-success(style="margin-right:20px;") 赞助成功啦！~
            br
            h5.text-danger 请前往游戏中领取订单商品！
            .text-info 
              ul
                li Vis币找“商城销售员”领取，并购买商品。
                li VIP票找“会员销售员”领取，并兑换会员证。
            .text-right
              button.btn.btn-info(@click="reset") 返回
</template>

<script>
import * as paymentAPI from '@/api/payment';

/* global $ */
export default {
  data() {
    return {
      isLoading: false,
      process: 0, // -1. 关闭赞助 0.填表单 1.订单生成(显示支付码) 2.显示支付结果
      submitHide: false, // 可查看赞助页面，但无法点击赞助按钮（提示暂时关闭）
      pay_type: '',
      form: {
        userid: '',
        money: null,
        result: {
          code: 0,
          orderid: '',
          pay_url: '',
          pay_qrcode: '',
          message: ''
        },
        notifyResult: {
          code: 0,
          message: ''
        }
      },
      interval: null
    };
  },
  methods: {
    confirmOrder() {
      let vm = this;
      vm.$validator.validate().then((validateResult) => {
        if (!validateResult) return;
        if (this.isLoading) return;
        this.isLoading = true;
        paymentAPI.createOrder({
          "userid": vm.form.userid,
          "amount": vm.form.money,
          "title": "99Ro",
          "type": (() => {
            switch (vm.pay_type) {
              case "coin": return "v";
              case "ticket": return "p";
            }
          })()
        }).then((res) => {
          vm.form.result.code = res.data.code;
          vm.form.result.message = res.data.message;
          if (res.data.data) {
            vm.form.result.orderid = res.data.data.orderid;
            vm.form.result.pay_url = res.data.data.url;
            vm.form.result.pay_qrcode = res.data.data.url_qrcode;
            this.process = 1;
            // 添加定时器刷新支付结果
            vm.interval = setInterval(() => {
              vm.refreshOrder();
            }, 4000);
          }
          switch (vm.form.result.message) {
            case "用户不存在":
              vm.form.result.message = "用户名不存在，请检查是否输入正确"
              break;
          }
        }).catch((err) => {
          vm.form.result.code = -1;
          console.log(err);
        }).finally(() => {
          this.isLoading = false;
        });
      });
    },
    refreshOrder() {
      let vm = this;
      if (this.isLoading) return;
      this.isLoading = true;
      paymentAPI.queryOrder(vm.form.result.orderid).then((res) => {
        vm.form.notifyResult.code = res.data.code;
        switch (res.data.message) {
          case "支付成功":
            clearInterval(vm.interval);
            vm.interval = null;
            this.process = 2;
            break;
          case "待支付":
            break;
          default:
            vm.form.notifyResult.message = res.data.message;
            break;
        }
      }).catch((err) => {
        console.log(err);
      }).finally(() => {
        this.isLoading = false;
      });

    },
    reset() {
      this.process = 0;
      this.pay_type = '';
      this.form.money = null;
      this.form.result.code = 0;
      this.form.result.orderid = '';
      this.form.result.message = '';
    }
  },
  beforeDestroy() {
    let vm = this;
    if (vm.interval) {
      clearInterval(vm.interval);
      vm.interval = null;
    }
  }
};
</script>

<style lang="scss" scoped>
.p-top {
  padding-top: 91px;
}
.cart-bg {
  background-image: url(http://res.99ro.top/web-assets/img/background1.jpg);
  background-position: center;
  background-repeat: no-repeat;
  width: 100%;
  height: 375px;
}
.cart-text {
  background-color: rgba(0, 0, 0, 0.6);
  padding: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/Payment.vue